module.exports = __webpack_public_path__ + "media/images/icons/outlined/profile-431a60a4285e2a2b074ced78cb1e400e.svg";